<div class="row my-4">
  <div class="col-lg-12 p-4" class="title">

    <nb-select
      name="scenario" class="me-2 nb-select-scenario"
      [ngModel]="leftScenario?.id"
      [placeholder]="'pages.common.select-scenario-dialog.select' | translate"
      (selectedChange)="selectScenario('left', $event)"
      [style.backgroundColor]="leftScenario?.color || 'white'"
      [class]="leftScenario?.color ? styleService.textColorBasedOnBgColor(leftScenario.color) : 'black'"
    >
      @for (scenar of (leftScenarii$ | async); track scenar) {
        <nb-option [value]="scenar.id">{{ scenar.name }}</nb-option>
      }
    </nb-select>

    {{ "pages.decision.analysis.vs" | translate }}

    <nb-select
      name="scenario"
      class="ms-2 nb-select-scenario"
      [ngModel]="rightScenario?.id"
      [placeholder]="'pages.common.select-scenario-dialog.select' | translate"
      (selectedChange)="selectScenario('right', $event)"
      [style.backgroundColor]="rightScenario?.color || 'white'"
      [class]="rightScenario?.color ? styleService.textColorBasedOnBgColor(rightScenario.color) : 'black'"
    >
      @for (scenar of (rightScenarii$ | async); track scenar) {
        <nb-option [value]="scenar.id">{{ scenar.name }}</nb-option>
      }
      @if ((rightScenarii$ | async)?.length > 0 && rightScenario) {
        <nb-option [value]="null">
          {{ 'Cancel comparison' | translate }}
        </nb-option>
      }
    </nb-select>

  </div>
</div>
